import script from "./DescriptionSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionSlide.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionSlide.vue?vue&type=style&index=0&id=aef44fd4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aef44fd4"]])

export default __exports__